// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RgaInfo from './rga-info.js';
import RgaSearchResults from '../state/rga-search-result';
import SmartFormAttachmentLink from './smart-form-attachment-link/smart-form-attchment-link.js';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getRequestIcon} from '../../shared/services/get-request-icon.js';

class RgaResultListItem extends Component {
    constructor(props) {

        super(props);
        this.state = {
            selectedRga: []
        };
        this.onClickViewDetailsFormBtn = this.onClickViewDetailsFormBtn.bind(this);

    }

    onClickViewDetailsFormBtn() {

        this.props.actions.setRgaResultsNavigation({
            currentPage: this.props.currentPage,
            lastOpenedRgaNumber: this.props.item.rgaNumber,
            shouldRestore: true
        });

        this.props.actions.getRgaDetails(this.props.item);

    }

    handleRgaSelect(rgaAccount, account, isSelected) {

        this.setState(prevState => ({
            selectedRga: isSelected ?
                [...prevState.selectedRga, rgaAccount] :
                prevState.selectedRga.filter(f => f.rgaNumber !== rgaAccount.rgaNumber)
        }));

        this.props.onSelectRga(rgaAccount, isSelected);

    }

    render() {

        const {parenpropsLocation, item, infoReqStatus, partReqStatus, photoReqStatus, actions} = this.props;

        return (
            <section
                className='rga-result-item'
                data-rga-search-number={item.rgaNumber}
            >
                <main>
                    <header className='part-return-description'>
                        {parenpropsLocation && parenpropsLocation.pathname && parenpropsLocation.pathname.includes('mass-update') &&
                            <Checkbox
                                id={item.rgaNumber}
                                onChange={this.handleRgaSelect.bind(this, item)}
                                selected={createHashMap(this.props.rgaNumbersList, 'rgaNumber')[item.rgaNumber] || false}
                            >{''}</Checkbox>}
                        <a
                            onClick={this.onClickViewDetailsFormBtn}
                        >
                            <div className={getRequestIcon(item.rgaSubType)}/>
                            <span>
                                {item.rgaSubType} {item.stripLeadingZerosForRgaNumber()}
                            </span>
                        </a>
                    </header>
                    <RgaInfo
                        infoReqStatus={infoReqStatus}
                        item={item}
                        partReqStatus={partReqStatus}
                        photoReqStatus={photoReqStatus}
                    />
                </main>
                <footer>
                    <section className='button-group'>
                        <SmartFormAttachmentLink
                            actions={actions}
                            currentPage={this.props.currentPage}
                            displayText='Attachment'
                            formName='RGA'
                            icon={'PDF'}
                            objectId={item}
                            rgaNumber={item.rgaNumber}
                            showAsButton={true}
                            showButtonIcon={true}
                            translate={false}
                        />
                        <button
                            className='button-primary'
                            onClick={this.onClickViewDetailsFormBtn}
                        >
                            <FormattedMessage id='VIEW_DETAILS'/>
                        </button>
                    </section>
                </footer>
            </section>
        );

    }
}

RgaResultListItem.displayName = 'RgaResultListItem';
RgaResultListItem.propTypes = {
    actions: PropTypes.object.isRequired,
    currentPage: PropTypes.number.isRequired,
    infoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    item: PropTypes.instanceOf(RgaSearchResults).isRequired,
    onSelectRga: PropTypes.func.isRequired,
    parenpropsLocation: PropTypes.object.isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    photoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    rgaNumbersList: PropTypes.arrayOf(PropTypes.object)
};

export default RgaResultListItem;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/components/rga-list-item.js